export default "/biometrie-afghanistan/media/18f67f7ce9b33f057e9d7896deb3d36b~sebi.jpg";